import { Link, useLocation } from "wouter";

import { useIsSessionLive } from "@/hooks/use-is-session-live";

const links = [
  ["/", "Race centre"], ["/sessions", "Sessions & replays"],
  ["/calendar", "Calendar"], ["/standings", "Standings"],
  ["/drivers", "Drivers"], ["/analysis", "Analysis"], ["/stats", "Stats"], ["/circuits", "Circuits"], ["/guides", "Guides"],
];

export function TopNavigation() {
  const [location] = useLocation();
  const { isLive } = useIsSessionLive();
  return <header className="top-navigation">
    <Link href="/" className="top-brand" aria-label="F1 Tracker home">
      <svg className="racing-brand-mark" width="40" height="28" viewBox="0 0 42 28" aria-hidden="true"><g transform="matrix(1 0 -.22 1 6 0)" fill="currentColor"><path d="M0 3h15v5H6v4h7v5H6v8H0Z"/><path d="M18 3h18v5h-6v17h-6V8h-6Z"/></g></svg><span>F1 Tracker</span>
    </Link>
    <nav aria-label="Main navigation" className="top-navigation-links">
      {links.map(([href, label]) => <Link key={href} href={href}
        aria-current={location === href ? "page" : undefined}>
        {label}{href === "/" && isLive && <span className="nav-live">Live</span>}
      </Link>)}
    </nav>
  </header>;
}
